import React, { useContext } from 'react';

import {
  Platform,
  StyleSheet,
  ToastAndroid,
  TouchableHighlight,
  View,
} from 'react-native';
import { SvgXml } from 'react-native-svg';
import DyteText from './DyteText';
import { defaultIconPack, IconPack } from '../lib/icons';
import { DyteI18n, useLanguage } from '../lib/lang';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({
  meeting,
  size,
  iconPack = defaultIconPack,
  t,
}: {
  meeting: any;
  size?: 'lg' | 'md' | 'sm' | 'xl';
  iconPack?: IconPack;
  t?: DyteI18n;
}) {
  const { storeStates } = useContext(DyteUIContext);
  const { colors } = storeStates.designSystem;
  const defaultLang = useLanguage();
  t = t ?? defaultLang;
  iconPack = iconPack ?? defaultIconPack;
  let buttonSize = 25;
  switch (size) {
    case 'md':
      buttonSize = 50;
      break;
    case 'lg':
      buttonSize = 100;
      break;
    case 'xl':
      buttonSize = 150;
      break;
  }
  const styles = StyleSheet.create({
    container: {
      alignItems: 'center',
      justifyContent: 'center',
    },
    button: {
      height: 52,
      width: '100%',
      backgroundColor: colors.background[1000],
    },
    buttonContainer: {
      flexDirection: 'row',
      paddingVertical: 12,
      paddingLeft: 48,
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    icon: {
      marginTop: 4,
    },
    text: { paddingHorizontal: 18, color: colors.text },
  });
  if (
    meeting.meta.viewType === 'WEBINAR' &&
    meeting.stage.status === 'OFF_STAGE'
  )
    return null;
  if (!meeting.self.permissions.canAllowParticipantAudio) return null;
  return (
    <View style={styles.container}>
      <TouchableHighlight
        underlayColor={colors.background[800]}
        onPress={() => {
          meeting.participants
            .disableAllAudio(true)
            .catch((err) =>
              Platform.OS === 'ios'
                ? console.log(err)
                : ToastAndroid.show(err.toString(), ToastAndroid.SHORT)
            );
        }}
        style={styles.button}
      >
        <View style={styles.buttonContainer}>
          <View style={styles.icon}>
            <SvgXml
              xml={iconPack.speaker_off.replace('currentColor', colors.text)}
              width={buttonSize}
              height={buttonSize}
            />
          </View>
          <DyteText style={styles.text}>{t('mute_all')}</DyteText>
        </View>
      </TouchableHighlight>
    </View>
  );
}
